<template>
  <div class="f7-panel">
    <slot></slot>
  </div>
</template>